import { get } from "lodash";
import { StageDCommentsInfo, StageDMessageInfo, StageDocumentsInfo } from "../stage-d/Review-Application.class";
import { SubmitDocuments } from "../CooSubmission.class";

export interface SolicitorCorrespondenceAdditionalInfo {
  mortgage_payee?: string;
}

export class SolicitorCorrespondenceRequest {
  application_uuid: string;
  message_info: MessageReplyRequest[];
  folders: FolderReplyRequest[];
  additional_documents: SubmitDocuments[];
  additional_info: SolicitorCorrespondenceAdditionalInfo;

  constructor(
    application_uuid: string,
    replied_by: string,
    message_info: StageDMessageInfo[] = [],
    folders: StageDocumentsInfo[] = [],
    additional_documents: SubmitDocuments[],
    additional_info = {},
  ) {
    this.application_uuid = application_uuid;
    this.message_info = message_info.map((message) => new MessageReplyRequest(message, replied_by));
    this.folders = folders.map((folder) => new FolderReplyRequest(folder, replied_by));
    this.additional_documents = additional_documents;
    this.additional_info = additional_info;
  }
}

class MessageReplyRequest {
  uuid: string;
  parent_uuid: string;
  reply: string;
  replied_by: string;

  constructor(stageDMessageInfo: StageDMessageInfo, replied_by: string) {
    this.uuid = get(stageDMessageInfo, "uuid", "");
    this.parent_uuid = get(stageDMessageInfo, "parent_uuid", "");
    this.reply = get(stageDMessageInfo, "reply", "");
    this.replied_by = replied_by;
  }
}

class FolderReplyRequest {
  uuid: string;
  replied_by: string;
  comments: StageDCommentsInfo[];
  documents: SubmitDocuments[];

  constructor(stageDocumentsInfo: StageDocumentsInfo, replied_by: string) {
    this.uuid = get(stageDocumentsInfo, "uuid", "");
    this.comments = get(stageDocumentsInfo, "comments", []);
    this.documents = get(stageDocumentsInfo, "documents", []);
    this.replied_by = replied_by;
  }
}
